import classNames from 'classnames';
import './index.less';

const SectionTitle = ({ title, children, className }) => {
    return (
        <div
            className={classNames('section-title', className, {
                ['section-title-with-actions']: children,
            })}
        >
            <h4>{title}</h4>
            {children && <div className='section-title-actions'>{children}</div>}
        </div>
    );
};

export default SectionTitle;
